const polyfill = new Promise((resolve) => {
  if (!window.Intl) {
    require.ensure([], (require) => {
      require('intl')
      require('intl/locale-data/jsonp/en')
      require('intl/locale-data/jsonp/de')
      require('intl/locale-data/jsonp/fr')
      require('intl/locale-data/jsonp/es')
      require('intl/locale-data/jsonp/zu')
      resolve()
    })
  } else {
    resolve()
  }
})

export default polyfill
